import React, { Fragment } from "react";
import Header2 from "../../components/header/Header2";
import { Link } from "react-router-dom";
import Scrollbar from "../../components/WhatsAppBtn/WhatsAppBtn";
import CtaSection from "../../components/CtaSection/CtaSection";
import Footer from "../../components/footer/Footer";
import Bg from "../../images/bg/page_bg01.jpg";
import icon from "../../images/icon/eye-icon.svg";
import caseImg from "../../images/testimonial/sa-tes02.jpg";
import cIcon1 from "../../images/icon/csd-icon01.svg";
import cIcon2 from "../../images/icon/csd-icon02.svg";
import cIcon3 from "../../images/icon/csd-icon03.svg";
import cIcon4 from "../../images/icon/csd-icon04.svg";
import cIcon from "../../images/icon/check-icon.svg";
import caseStudies from "../../api/case";

const CaseStudyDisasterRecovery = (props) => {
  const ClickHandler = () => {
    window.scrollTo(10, 0);
  };

  return (
    <Fragment>
      <div className="body_wrap sco_agency">
        <Header2 />
        <section
          className="page-title pt-200 pos-rel bg_img"
          style={{ backgroundImage: `url(${Bg})` }}
        >
          <div className="container">
            <div className="page-title-wrap">
              <div className="row mt-none-30 align-items-end">
                <div className="col-lg-9 mt-30">
                  <div className="page-title-box">
                    <span className="sub-title">
                      <img src={icon} alt="" /> Caso de Sucesso
                    </span>
                    <h2 className="title">
                      Disaster Recovery para Grupo Hospitalar <br /> garantindo
                      RTO de 15 minutos <br /> e RPO zero
                    </h2>
                  </div>
                </div>
                <div className="col-lg-3 mt-30">
                  <div className="count-box">
                    <h2 className="number">
                      15<span className="suffix">min</span>
                    </h2>
                    <span className="text">
                      tempo de recuperação <br /> garantido
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <div className="csd-img pt-70 pb-65">
          <div className="container">
            <div className="item-details_image pos-rel">
              <img src={caseImg} alt="Disaster Recovery - Grupo Hospitalar" />
            </div>
          </div>
        </div>
        <div className="sd-ser-content_wrap pb-90">
          <div className="container">
            <div className="sd-ser-content">
              <h2 className="sd-title">
                O desafio: continuidade crítica em ambiente hospitalar
              </h2>
              <p className="sd-content">
                Um grupo hospitalar com 5 unidades e mais de 2.000 leitos
                enfrentava um problema crítico: a ausência de um plano de
                disaster recovery adequado. O grupo dependia inteiramente de
                sistemas locais para prontuários eletrônicos, sistemas de
                farmácia, controle de UTI e equipamentos médicos conectados. Uma
                falha de infraestrutura poderia resultar em risco de vida para
                pacientes e violação de normas da ANVISA e CFM.
              </p>
              <br />
              <p className="sd-content">
                A situação se tornou urgente após um incêndio em um dos
                datacenters locais, que causou 6 horas de inatividade em
                sistemas críticos. Durante esse período, o atendimento foi
                prejudicado, cirurgias foram canceladas e o grupo enfrentou
                auditoria rigorosa dos órgãos reguladores. A necessidade de uma
                solução robusta de disaster recovery tornou-se questão de
                conformidade regulatória e segurança do paciente.
              </p>
            </div>
          </div>
        </div>
        <div className="csd-ser_warp">
          <div className="container">
            <div className="csd-ser_inner ul_li_between">
              <div className="csd-item ul_li">
                <div className="xb-icon">
                  <img src={cIcon1} alt="" />
                </div>
                <h6 className="xb-text">
                  cliente : <span> Grupo Hospitalar Regional</span>
                </h6>
              </div>
              <div className="csd-item ul_li">
                <div className="xb-icon">
                  <img src={cIcon2} alt="" />
                </div>
                <h6 className="xb-text">
                  serviços : <span> Disaster Recovery + Cloud</span>
                </h6>
              </div>
              <div className="csd-item ul_li">
                <div className="xb-icon">
                  <img src={cIcon3} alt="" />
                </div>
                <h6 className="xb-text">
                  conclusão : <span> 30 dias</span>
                </h6>
              </div>
              <div className="csd-item ul_li">
                <div className="xb-icon">
                  <img src={cIcon4} alt="" />
                </div>
                <h6 className="xb-text">
                  localização : <span> Região Metropolitana, Brasil</span>
                </h6>
              </div>
            </div>
          </div>
        </div>
        <div className="sd-service_wrap pt-90 pb-130">
          <div className="container">
            <div className="sd-ser-outcome">
              <div className="sd-heading">
                <h2 className="sd-title">Requisitos do projeto</h2>
                <p className="sd-content">
                  O cliente necessitava de uma solução que garantisse
                  continuidade operacional crítica 24/7, cumprimento das normas
                  ANVISA e CFM, RPO (Recovery Point Objective) zero para
                  sistemas críticos, RTO (Recovery Time Objective) inferior a 15
                  minutos, além de auditoria e relatórios de conformidade.
                </p>
              </div>
              <div className="sd-list-item ul_li">
                <ul className="sd-ser-list list-unstyled">
                  <li>
                    <img src={cIcon} alt="" />
                    Análise de impacto de negócio (BIA)
                  </li>
                  <li>
                    <img src={cIcon} alt="" />
                    Classificação de sistemas críticos
                  </li>
                  <li>
                    <img src={cIcon} alt="" />
                    Replicação em tempo real de dados
                  </li>
                  <li>
                    <img src={cIcon} alt="" />
                    Failover automático para sistemas críticos
                  </li>
                </ul>
                <ul className="sd-ser-list list-unstyled">
                  <li>
                    <img src={cIcon} alt="" />
                    Testes de disaster recovery mensais
                  </li>
                  <li>
                    <img src={cIcon} alt="" />
                    Monitoramento 24/7 de infraestrutura
                  </li>
                  <li>
                    <img src={cIcon} alt="" />
                    Relatórios de conformidade regulatória
                  </li>
                  <li>
                    <img src={cIcon} alt="" />
                    Plano de comunicação de crise
                  </li>
                </ul>
              </div>
            </div>
            <div className="sd-heading csd-heading pt-90">
              <h2 className="sd-title">Solução implementada & resultados</h2>
              <p className="sd-content">
                <span>Solução:</span> Implementamos uma arquitetura de disaster
                recovery híbrida com replicação em tempo real para datacenters
                geograficamente separados. Os sistemas críticos foram
                classificados em três níveis de prioridade, com failover
                automático para Tier 1 (prontuários, UTI, farmácia) em menos de
                15 minutos. Estabelecemos procedimentos de teste mensal,
                monitoramento proativo e dashboards de conformidade regulatória.
              </p>
              <br />
              <p className="sd-content">
                <span>Resultados:</span> O grupo hospitalar alcançou 99.99% de
                disponibilidade dos sistemas críticos, RTO de 15 minutos e RPO
                zero para sistemas Tier 1. Durante os 12 meses seguintes, foram
                realizados 3 failovers automáticos sem impacto no atendimento. O
                grupo passou em todas as auditorias regulatórias e reduziu em
                90% o tempo de inatividade não planejada. A solução garantiu
                continuidade operacional durante a pandemia, quando a demanda
                por leitos aumentou 300%.
              </p>
            </div>

            <div className="similar-casestudy pt-80">
              <h2 className="similar-casestudy-title">Casos similares</h2>
              <div className="row mt-none-30">
                {caseStudies.slice(3, 6).map((cases, citem) => (
                  <div className="col-lg-4 col-md-6 mt-30" key={citem}>
                    <div className="casestudy-item">
                      <div className="casestudy-img">
                        <Link
                          onClick={ClickHandler}
                          to={`/casestudy-details/${cases.slug}`}
                        >
                          <img src={cases.img} alt="" />
                        </Link>
                        <div className="content_wrap">
                          <h3 className="item_title">{cases.title}</h3>
                          <span className="item_tag">{cases.slug}</span>
                        </div>
                      </div>
                      <Link
                        onClick={ClickHandler}
                        to={`/casestudy-details/${cases.slug}`}
                        className="xb-overlay"
                      ></Link>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
        <CtaSection />
      </div>
      <Footer />
      <Scrollbar />
    </Fragment>
  );
};
export default CaseStudyDisasterRecovery;
